// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class FileInputReset extends WebComponent {
	didMount() {
		const {
		} = this.props;


		this.element.addEventListener('change', (e) => {
			if(e.target.value !== '') {
				const resetButton = document.createElement('button');
				resetButton.innerHTML = 'Reset';
				resetButton.classList.add('file-input--reset');
				resetButton.addEventListener('click', () => {
					this.element.value = '';
					resetButton.remove();
				});
				this.element.insertAdjacentElement('afterend', resetButton);
			}
		});
	}

}



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/FileInputReset.js